import React from 'react';
import {render} from 'react-dom';

import 'eventbrite_design_system/css/eds.css';
import './app.scss';
import App from './App';

render(
    <App />,
    document.getElementById('root')
);
